var vil =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

//________________________________________________________________________________________________
// jquery.vil.js
//________________________________________________________________________________________________
//	history
//	date	engineer	change and reason for change
//	------  ---------   --------------------------------------------------------------------------
// 09 Feb 2012 SK		Add DSC object to hold DSC related settings
// 08 Jul 2012 SK		Move uScope calls out of here since those should be made after successful connection to DSC Server
// 29 Sep 2012 SK		Cleanup conf setup and manager dialog on close.
// 18 Mar 2013 RTE		add uScope events
// 13 May 2013 AR		removed function called twice --> Improved 150ms on loading of the DST
// 13 May 2013 AR		removed function called twice --> Improved 150ms on loading of the DST
// 13 Nov 2013 CP		remove trailing commas in vilSettings - IE is very sensitive to these
// 15 Nov 2013 CP		converted uscope nextPrevSlide from feature to toolbarOptions
// 140323 cperz			Conferencing Update: VilImageSelected: updated for multi-image reference; 
//						renderSlides: removed attempt to open undefined slide in uScope when displayDST is false;
//						removed commented out code blocks that were not traceable, probably old edit history;
// 140324 cperz         generalize for AIH: replace r12's abstraction of Ajax() with $.ajax(), ParseJSON() with JSON.parse();
// 140325 cperz         dstSettings: default to single slide selection;
// 140325 tdailey       incorporate Bob's conferencing work;
// 140402 cperz			specify and rename VILSYNC event to vil_evIMAGEREADY to correspond to us_evIMAGEREADY
// 140407 cperz			eventAjaxError: correct alert text
// 140407 rellis        added setVilInstance method
// 140415 tdailey       removed duplicated conferencing code and polling loop is now in conferencing
// 140513 cperz			if label visibility is prohibited, override dst and uScope's settings
// 140522 cboarman      fixed summary title updating; added new accordion setting 'displayHandlerTitle'
// 140528 cboarman      added summary title callback (summaryCallback) viewmodel property for overriding 
//                      the default summary text on slide tray and vertical bar
// 140601 cboarman      Added dst setting autoSelectSlide and default to true                     
//________________________________________________________________________________________________

/* global jsPAL, confEvent, SystemParms, uScope, leica, flashVars, swfobject */

var PinDropNavigator = __webpack_require__(8);

(function ($) {
    var uScope = window.uScope;

    // hack globals; these may not actually be defined anywhere, but they're used here.
    var _participant = window._participant;
    var Clone = window.Clone; // Defined in spectrum.js

    var eventNameSpace = ".VIL";
    var configurationStorage = [];

    var defaultSettings =
            {
                "conferencing": false,
                "tableName": "Case",
                "currentId": "",
                "priorId": "",
                "browser": "",
                "ignoreResize": false,
                "displayMode": "embedded", // other options "popup" or "fullscreen"
                "displayDST": true,
                "displayViewer": true,
                "displayPinDropNav": true,
                "displayLabels": true,
                "lockMode": false, // true if user does not have edit access to the case, or the case tab is locked on the main tabs row
                "iosMode": false, // true if running on ios device
                "refreshRequired": false,
                "usePAL": false,
                "flashViewer":
                        {
                            "flashVars": "",
                            "movieSrc": ""
                        },
                "dstInfo": {},
                "vilSettings":
                        {
                            "divId": ""
                        },
                "accordionSettings":
                        {
                            "divId": "accordionContainer",
                            "divHandlerId": "accordionHandlerContainer",
                            "divImport": null,
                            "collapseTrayCallback": "collapseTray",
                            "collapsed": false,
                            "divImportDst": null,
                            "displayHandlerTitle": true
                        },
                "dstSettings":
                        {
                            "divId": "dstContainer",
                            "dstTitle": "eSlide Tray",
                            "caption": "",
                            "displayGroupings": true,
                            "displayGroupTitles": false,
                            "displayLabels": true,
                            "displayMemos": true,
                            "iconOrientation": "right", // note - this must be either "left" or "right"
                            "displayBackgroundHighlight": false,
                            "displaySlideInfo": true,
                            "displayPosNegControl": false,
                            "displayMultiSlide": false,
                            "allowMemoEdit": true,
                            "displaySummaryTitle": true,
                            "enableEnhancedView": true,
                            "enableLabelPopup": false,
                            "enableReordering": true,
                            "enableMultiTray": true,
                            "enableToggleReadStatus": true,
                            "allowRemoveSlides": false,
                            "allowDeleteSlides": false,
                            "allowToggleRead": true,
                            "allowContextMenu": true,
                            "allowMultipleSelections": true,
                            "slidesPerTray": 20,
                            "slidesPerColumn": 10,
                            "traysPerMulti": 3,
                            "uniqueId": "",
                            "lockMode": false,
                            "iosMode": false,
                            "multiTrayWidth": 1300,
                            "multiTrayHeight": 525,
                            "loadPriors": true,
                            "height": 0,
                            "autoSelectSlide": true
                        },
                "uScope":
                        {
                            "setup":
                                    {
                                        "divId": "uscope",
                                        "userName": "",
                                        "title": "",
                                        "userid": "",
                                        "createdBy": "VIL"
                                    },
                            "toolbarOptions":
                                    {
                                        "openImageScopeBtn": true,
                                        "dscSetupBtn": true,
                                        "resizeBtn": true,
                                        "openPDNBtn": true,
                                        "autoRaster": false,
                                        "nextPrevSlide": false,
                                        "printBtn": true,
                                        "imageAdjustment": true
                                    },
                            "overlays":
                                    {
                                        "label": false, // get from UserRights
                                        "magnifier": true,
                                        "thumbnail": true,
                                        "scalebar": true,
                                        "zoombar": true,
                                        "rotation": true,
                                        "heatmap": false,
                                        "none": false
                                    },
                            "extensions": {
                                "us:imagescope-launcher": {
                                    "targetUrlTemplate": '/BulkAction.php?Command=BulkImageScopeView&&ImageIds[]={IMAGE_IDS}&TableName=Image',
                                    "filename": "DigitalSlides.sis"
                                }
                            },
                            "features":
                                    {
                                        "annotationsEnabled": true,
                                        "dscEnabled": true,
                                        "linkToImage": true,
                                        "saveMacro": true,
                                        "runAnalysis": true,
                                        "snapshotMode": "printViewport"
                                    },
                            "images": [
                                // Do not remove this default images property of uScope (empty array) - it will be merged in if not present, and it's presense may be assumed by uScope
                                // Furthermore, do not remove the commented out sample image below - it serves as a example for how to inject images via VIL constructor

                                // { // up to four images
                                // 	"imagePath": "", 	// @123
                                // 	"fullURL": "", 		// aperio-00816/imageserver/@@CsZ9kj_25A2bkO8hd6hHmE8QrjFvdQszvEl3oCYzPIEEjpaWGu0KWQ==/@123
                                // 	"x": "",
                                // 	"y": "",
                                // 	"z": "", 			// Z-index
                                // 	"mag": "Fit", 		// "Fit", "Scan" or "2", "4", "10", etc
                                // 	"regionId": "",
                                // 	"saveAnnotations": true  // user rights: if user has full access to the datagroup for the image
                                // }
                            ]
                        },
                "pindrop":
                        {
                            "listObj": Array(), // some of these should be internal
                            "primarycaseId": "",
                            "displayCollapsed": false, // expose publically
                            "selectedIndex": 0,
                            "selectedRegionId": 0,
                            "maxPindrops": 5
                        },
                "DSC":
                        {
                            "dscId": "",
                            "authToken": "",
                            "fullName": "",
                            "userId": "",
                            "confManagerDivId": "",
                            "vilDivId": ""
                        },
                "parentDiv": "",
                "workFlowDiv": "",
                "popupTitle": "",
                "simulate": false
                        // for DST
            };

    /*
     * Singleton methods to call VIL
     */
    var __vilInstance__;
    var __dstInstance__ = null;
    var __accordionInstance__ = null;


    jQuery.getVilInstance = function () {
        return __vilInstance__;
    };

    jQuery.setVilInstance = function (vilDiv) {
        __vilInstance__ = vilDiv;
        return __vilInstance__;
    };

    jQuery.getDstInstance = function () {//so dst extention can cleanly get to the dst
        return __dstInstance__;
    };

    jQuery.fn.vil = function (options) {
        var self = this;
        var pdn;

        /*
         * This is the reserved internal variable only to be used for instantication and singleton get methofds
         */
        __vilInstance__ = this;

        // VIL events
        var vil_evIMAGEREADY = "vil_evIMAGEREADY";

        // if the selctor return null we need to stop immediatelly. the javascript at runtime will throw any errors
        if (self.length == 0) {
            return null;
        }
        var settings = configurationStorage[self.attr("id")] == null ? null : configurationStorage[self.attr("id")];

        self.uScopeStarted = false;  // private internal boolean to track status of uScope: i.e, has been started yet?

        /*************************************************************************************************************
         PUBLIC FUNCTIONS -- this are the functions which are available from the instance.
         *************************************************************************************************************/

        self.getConfiguration = function () {
            return settings;
        };

        self.getAccordion = function (reload) {
            if (reload) {
                __accordionInstance__ = self.find('#' + settings.accordionSettings.divId).customaccordion(self);
            }
            return __accordionInstance__;
        };

        self.getDst = function (reload) {
            if (reload) {
                __dstInstance__ = self.find('#' + settings.dstSettings.divId).dst(self);
            }
            return __dstInstance__;
        };

        self.init = function (options) {
            var resultPromise;

            if (settings == null) {
                settings = {};
            }

            $.extend(true, settings, defaultSettings);

            if (options) {
                $.extend(true, settings, options); // Merges options with existing settings obj
            }
            settings.initialLockMode = settings.lockMode;
            settings.parentDiv = self.parent();
            settings.workFlowDiv = settings.parentDiv.parent();

            // Set browser
            if ((/MSIE (\d+\.\d+);/.test(navigator.userAgent)) || /Trident/.test(navigator.userAgent)) {
                settings.browser = 'IE';
            }
            else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent))
                settings.browser = 'Firefox';
            else if (/Chrome[\/\s](\d+\.\d+.\d+\.\d+)/.test(navigator.userAgent))
                settings.browser = 'Chrome';

            // eSM used AJAX wrapper for $.ajax. This doesn't exist in AIH
            if ('undefined' === typeof window.Ajax) {
                window.Ajax = $.ajax;
            }

            settings.vilSettings.divId = '#' + this.attr('id');
            settings.dstSettings.iosMode = settings.iosMode;

            if (settings.displayLabels == false) {				// if label visibility is prohibited, override dst and uScope's settings
                settings.dstSettings.displayLabels = settings.displayLabels;
                settings.uScope.overlays.label = settings.displayLabels;
            }

            configurationStorage[self.attr("id")] = settings;

            if (settings.flashViewer.flashVars != "") {
                settings.displayDST = false; // Disable DST when loading Flash viewer
            }
            // if running in a tab, disable all the tabs in that tab row
            // to prevent user from switching tabs before the dst and uScope
            // have fully initialized. tabs will be re-enabled in the us_evIMAGEREADY event handler
            if (settings.displayViewer && self.parent().hasClass('ui-tabs-panel')) {
                var tabs = self.parent().closest('.tabs');
                tabs.find('ul li').each(function (index, value) {
                    tabs.tabs('disable', index);
                    // if the <a> has an onclick handler, disable that too
                    $(this).find('a.ui-tabs-anchor').each(function () {
                        var onclick = $(this).attr('onclick');
                        if (onclick && onclick != '') {
                            $(this).attr('onclick', 'return false;' + onclick);
                        }
                    });
                });
            }
            // If a case (or other hierarchy) currentId is set, this code will load the slides for that case
            // possibly via an Ajax call. A promise is returned so callers creating a VIL can respond when the VIL is fully created 
            if ((settings.currentId != '') && settings.displayDST) {
                if (settings.priorId.length) {
                    resultPromise = loadSlides(settings.currentId, settings.priorId);
                }
                else {
                    resultPromise = loadSlides(settings.currentId, null);
                }

            }
            // This section of code is used when dispalying a arbitrary list of slides rather than a case
            // settings.dstInfo should contain the list of slides - no ajax call to server is needed.
            // The default empty promise returned in this case is immediately resolvable
            else {
                if (settings.displayDST && (!jQuery.isEmptyObject(settings.dstInfo))) {
                    var accordion = self.getAccordion(true); // creates the singleton
                    accordion.renderAccordion();
                    renderDST(settings.dstInfo, true);
                    accordion.renderAccordionHandler();
                }
                if (settings.displayViewer) {
                    renderViewer();
                    if (settings.displayDST && (!jQuery.isEmptyObject(settings.dstInfo))) {
                        var accordion = self.getAccordion();
                        if (accordion)
                            accordion.setAccordionHandlerHeight();
                    }
                }
            }

            tabEventHandlers(); 						// attach to the tab related events
            uScopeEventHandlers(false);					// in case VIL is being reloaded, cancel any previous event handlers
            uScopeEventHandlers(true); 					// attach to the uScope events

            if ($.conference) {
                $.getVilInstance().conference('init'); 	    // init for conferencing 
            }

            pdn = new PinDropNavigator(self, uScope, settings);

            return resultPromise; // If an ajax call was made in load slides, this promise can be used to wait for VIL initialization completion
        };

        self.syncSlideMemosFromDst = function () {
            var dst = self.getDst();
            if (dst) {
                var vm = dst.getActiveViewModel();
                // At a minimum, loop through all the dst slides and update the memo field in the dstInfo
                if (vm) {
                    $.each(vm.cases, function (index, theCase) {
                        if (theCase.isPrimaryCase) {
                            var currentSlides = vm.getSlides(vm);
                            $.each(currentSlides, function (idx, slide) {
                                // for each slide, find corresponding slide in settings.dstInfo and update memo
                                if (!slide.isValidSlide || slide.isBlank)
                                    return;

                                var matchingSlides = settings.dstInfo.cases[index].slides.filter(function (s) {
                                    return s.imageId == slide.imageId;
                                });

                                if (matchingSlides.length > 0) {
                                    matchingSlides[0].memo = slide.memoContent();
                                }
                            });
                        };
                    });
                }
            }
        };

        /*
         * attach event handlers to the Tab related events
         */
        var tabEventHandlers = function () {
            $(document).on('PALTabClosing.VIL', function (event, tabDivId) {
                // tabDivId is the id of the tab panel div associated with the closing tab.
                // if the closing tab panel div contains the VIL parent div, then close the DST in the div
                if ($(tabDivId).find($(settings.parentDiv)).length > 0) {
                    closeDST();
                }
            });

            $(document).on('tabsshow.VIL', function (event, ui) {
                // Another tab has been chosen
                closeDST();
            });

            self.closest('.ui-tabs').on('tabsactivate.VIL', function (event, ui) {
                // refresh the VIL if required when the tab containing the VIL is shown
                if (settings.refreshRequired) {
                    // if tab contains this VIL
                    if ($(ui.panel).find(self).length > 0) {
                        // remove and recreate the DST
                        if (settings.displayDST && (!jQuery.isEmptyObject(settings.dstInfo))) {
                            if (typeof jsPAL === 'object') {
                                // will be closed in loadSlides(),
                                // which also sets settings.refreshRequired = false
                                jsPAL.displayNotification('Updating ...', 10);
                            }
                            self.find("#" + settings.dstSettings.divId).empty();

                            loadSlides(settings.currentId, null);

                        }
                        else {
                            settings.refreshRequired = false;
                        }
                    }
                }
            });
        };

        /*
         * event handlers for the uScope related events
         * 	on = true to attach the events, false to detach the events
         */

        var uScopeEventHandlers = function (on) {
            if (on) {
                if (settings.uScope.toolbarOptions.dscSetupBtn) {
                    $(document).on(confEvent.createBtn + eventNameSpace, function (event) {
                        eventCreateConference();
                    });
                }

                if (settings.uScope.toolbarOptions.resizeBtn) {
                    self.on("us_evRESIZECLICK.VIL", function (event) {
                        eventResizeClick();
                    });
                }

                if (settings.uScope.toolbarOptions.nextPrevSlide) {
                    // attaching VIL to uScope OpenNextSlide and OpenPrevSlide
                    self.on("us_evOPENNEXTSLIDE.VIL", function (event, parms) {
                        self.getDst().getActiveViewModel().moveNextSlide();
                    });

                    self.on("us_evOPENPREVSLIDE.VIL", function (event, parms) {
                        self.getDst().getActiveViewModel().movePrevSlide();
                    });
                }

                self.on("us_evIMAGECLOSE.VIL", function (event, parms) {
                    var imageId = parms.imageId;
                    self.getDst().getActiveViewModel().closeSlide(imageId);

                });

                self.on("us_evIMAGENAVIGATED.VIL", function (event, parms) {
                    eventImageNavigated(parms.imageId, parms.status);
                });

                uScope.events.on('us:annotations:region-change', function (context, params) {
                    pdn.eventAnnotChange(params.imageId, params.regionId, params.anShape, params.action);
                });

                self.on('us_evIMAGEREADY.VIL', function (e, parms) {	// imageready event indicates newly opened image is up
                    if (parms.status) {
                        self.trigger(vil_evIMAGEREADY, parms);
                    }
                });
                self.on('us_evAJAXERROR.VIL', function (e, parms) {
                    // Let any global ajax error handlers take care of these (see master.js)
                    if (!('ajaxError' in $._data(document, "events"))) {
                        eventAjaxError(parms);
                    }
                });
            }
            else {
				// remove all .VIL event handlers
                self.off("us_evRESIZECLICK.VIL us_evPDNAVCLICK.VIL " +
						 "us_evOPENNEXTSLIDE.VIL us_evOPENPREVSLIDE.VIL us_evIMAGECLOSE.VIL " +
						 "us_evIMAGENAVIGATED.VIL us_evANNOTCHANGE.VIL us_evIMAGEREADY.VIL " +
						 "us_evAJAXERROR.VIL ");
            }
        };

        /*
         * uScope Event Handlers
         */
        var eventCreateConference = function () {
            var confName = createConfSetupDialog(); // return "dsc name"
        };

        var eventImageNavigated = function (id, state) {
            if (typeof SystemParms !== 'undefined' && (SystemParms.DisableAutoSlideFlip === "1" || SystemParms.DSTSetAutoReadSlides === "0")) {
                return;
            }

            if (settings.displayDST) {
                // DST does not expect an @ sign
                id = id.replace("@", "");
                if (state == 'read') {
                    self.getDst().toggleRead(id, true);
                }
                else if (state == 'notRead') {
                    self.getDst().toggleRead(id, false);
                }

                // update accordion panels with slide count summary
                self.getDst().getActiveViewModel().isSummaryStale(true);
                self.getAccordion().refreshSummary();
            }

        };

        // this event is triggered by uScope when an AJAX error occurs
        var eventAjaxError = function (parms) {
            // parms object:
            // 	{imageId: @NUM, request: ImageServerRequest, jqXHR: jqXHR}
            if (parms.jqXHR.readyState >= 4) // ignore incomplete requests, likely due to navigating away from the page
            {
                alert("AJAX error: reqeust: " + parms.request + ", status: " + parms.jqXHR.statusText);
            }
        };

        var eventResizeClick = function () {
            loadPopup();
        };

        /*
         PRIVATE FUNCTIONS -- this are the functions which are available internally
         */

        var getDstInfo = function (primaryId, displayId)
        {
            // why are these side-effects here? -ccb

            settings.currentId = primaryId;
            var Parms = {TableName: settings.tableName, loadPriors: settings.dstSettings.loadPriors, PrimaryId: settings.currentId};
            // Add PAL module name if we are in HC (Network)
            if (window.jsPAL && window.jsPAL.getPALModuleName) {
                var tmpWorkFlow = window.jsPAL.getPALModuleName();
                if (tmpWorkFlow.toLowerCase() !== 'unknown') {
                    Parms.WorkFlow = tmpWorkFlow;
                }
            }

            if (displayId) {
                Parms.DisplayId = displayId;
                settings.priorId = displayId;
            }
            else {
                settings.priorId = "";
            }

            if (settings.simulate == true) {
                Parms.Simulate = 1;
            }

            return $.post('/DST_Get.php', Parms, null, 'json');

        };


        var loadSlides = function (primaryId, displayId) {
            var dfd = $.Deferred();
            var promiseSlidesLoaded = dfd.promise();
            var tableName = settings.tableName.toLowerCase();
            if (tableName == 'case' || tableName == 'project' || tableName == 'lesson') {
                promiseSlidesLoaded = getDstInfo(primaryId, displayId)
                        .done(function (data) {
                            if (data) {
                                if (data.hasOwnProperty('Alert')) {
                                    console.log("Error getting slide tray information: " + data.Alert);
                                    settings.dstSettings.dstTitle += (": " + data.Alert);
                                }
                                if (data.hasOwnProperty('DstInfo')) {
                                    settings.dstInfo = data.DstInfo;
                                }
                            } else {
                                console.log("Error getting slide tray information");
                                settings.dstSettings.dstTitle += (": Error getting slide tray information.");
                            }
                        })
                        .always(function () {
                            // if this is the primary case, restore the initial lock mode
                            if (null === displayId || undefined === displayId)
                                settings.lockMode = settings.initialLockMode;
                            // else if a prior case, set lock mode to true
                            else if (primaryId !== displayId)
                                settings.lockMode = true;

                            renderSlides(settings.dstInfo, !(displayId));
                            if (typeof jsPAL === 'object')
                                jsPAL.closeNotification();
                            settings.refreshRequired = false;
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            alert('Error getting DST: ' + textStatus + ' ' + errorThrown);
                        });
            }
            // If tablename is slide, then we ignore the dst_get and just load the list of slides as defined in dstInfo
            else if (tableName == 'slide') {
                renderSlides(settings.dstInfo, true);
                if (typeof jsPAL === 'object')
                    jsPAL.closeNotification();
                settings.refreshRequired = false;
                setTimeout(dfd.resolve);
            }
            else {
                dfd.reject({
                    Alert: 'Invalid table name, "' + tableName + '".'
                });
            }

            return promiseSlidesLoaded;
        };

        var renderSlides = function (dstInfo, isPrimary) {
            var accordion;
            if (settings.displayDST) {
                accordion = self.getAccordion(true);
                accordion.renderAccordion(); // note that child accordion elements may not be added yet
                renderDST(dstInfo, isPrimary);
                accordion.renderAccordionHandler();
            }
            // render the uScope viewer, unless this is happening during the a refresh
            if (settings.displayViewer) {
                if (false === settings.refreshRequired) {
                    renderViewer();
                }
            }

            // Determine which image to select/view
            if (settings.displayDST) {
                // clear out the global prevSelectedSlide if it is not present in uScope
                self.getDst().clearPrevSelectedSlide();
                // display the DST, which will select an image into uScope
                //if (isPrimary)
                self.getDst().selectDefaultSlide();

                accordion = self.getAccordion();
                if (accordion)
                    accordion.setAccordionHandlerHeight();
            }
        };

        /*
         * This is the function to render the DST from within VIL.
         * if the DST div is not initialized it will be created.
         */
        var renderDST = function (dstInfo, isPrimary) {
            var vil = self;
            if (vil.find('#' + settings.dstSettings.divId).length === 0) {
                self.getAccordion().importElements(); // add DST panel elements to accordion markup
            }
            else {
                saveDst(); // Save any changes to the currently displayed DST
            }

            var dst = self.getDst(true);
            // lock the DST if any of these are true:
            //  loading a prior case
            //  VIL is locked
            var lock = (!isPrimary) || (settings.lockMode);
            settings.dstSettings.lockMode = lock;

            // Clear any preset sizes to allow rendering to establish size
            dst.height('');
            vil.height('');
            settings.workFlowDiv.height('');

            dst.renderDST(dstInfo, settings.dstSettings, isPrimary);
            settings.dstSettings.height = dst.height(); // must be done after tray-handle adjustment
            self.getAccordion().refreshSummary();
        };

        var renderViewer = function () {
            if (settings.flashViewer.flashVars != "") {
                self.append("<div id='webscope'></div>");
                var params = {
                    menu: "false",
                    flashVars: settings.flashViewer.flashVars
                };
                var attributes = {};

                swfobject.embedSWF(settings.flashViewer.movieSrc, "webScope", "500", "500", "9.0.0", "/js/swfobject/expressInstall.swf", flashVars, params, attributes);
            }
            else {

                var $uScope = self.find('#' + settings.uScope.setup.divId);
                var alreadyExists = $uScope.length;
                if (alreadyExists == 0) {
                    $uScope = $("<div id=" + settings.uScope.setup.divId + "></div>");
                    self.append($uScope);
                    resize('Initial');
                }
                if (!self.uScopeStarted) {
					if (settings.uScope.images.length > 0)
					{
						// remove the images, they will be opened by pinning or selecting below
						var uscopeSlides = settings.uScope.images.splice(0);
					}
                    self.uScopeStarted = uScope.start(settings.uScope);
                }
				if (uscopeSlides)
				{
					var vm = self.getDst().getActiveViewModel();
					var dstSlides = vm.getSlides(vm);
					for (var us = 0; us < uscopeSlides.length; us++)
					{
						var uscopeSlide = uscopeSlides[us];
						for (var ds = 0; ds < dstSlides.length; ds++)
						{
							var dstSlide = dstSlides[ds];
							if (uscopeSlide.fullURL == dstSlide.fullURL)
							{
								if (uscopeSlide.isPinned)
								{
									dstSlide.isMultiSlideSelected(true);
								}
								else
								{
									vm.setSelectedSlide(vm, dstSlide);
								}
								break;
							}
						}
					}
				}
				else
				{
	                selectUnpinnedSlideInTray(settings.uScope.images);  // if an unpinned image specified the settings, make sure it is selected in the DST
				}

                uScope.lockDown(shouldLockuScope()); // lock uScope if running in locked mode or in ios mode
            }
        };

        var selectUnpinnedSlideInTray = function (images, notify) {
            if (typeof notify == 'undefined')
                notify = true;
            var unPinnedImages = images.filter(function (image) {
                return !image.isPinned;
            });
            // If the uscope settings have an image already opened, and it is not pinned, make sure it is selected in the DST
            if (unPinnedImages.length > 0) {
                var imagePath = unPinnedImages[0].imagePath;
                self.getDst().selectImageByImageId(imagePath.substring(1), notify);
            }
        };

        // Modes include 'Initial', 'Resize', and 'Reset'  
        var resize = function (mode) {
            var vil = self;

            // the accordion and the DST should be displayed in full.
            var offsetLeft = 0;
            var offsetTop = 0;

            if (settings.displayDST) {
                var accordionHandler = vil.find("#" + settings.accordionSettings.divHandlerId);
                if (settings.accordionSettings.collapsed && accordionHandler.length > 0) {
                    // if the accordion is collapse only the tray-handle will be exposed.
                    offsetLeft = accordionHandler.outerWidth();
                    offsetTop = accordionHandler.offset().top;

                }
                else {
                    var accordion = vil.find("#" + settings.accordionSettings.divId);
                    if (accordion.length > 0) {
                        //  accordion width = accordion width + tray-handle witdh
                        offsetLeft = accordion.outerWidth() + accordionHandler.outerWidth();
                        offsetTop = accordion.offset().top;
                    }
                }
            }

            // uScope
            if (settings.displayViewer) {
                var uScopeWidth, uScopeHeight;
                var $uScope = vil.find('#' + settings.uScope.setup.divId);
                uScopeWidth = self.width() - offsetLeft - 4;
                uScopeHeight = $(window).height() - offsetTop; // (note that $(window).height() == window.innerHeight)

                if (settings.displayMode === "popup") {
                    //TODO: perhaps we need to check for AIH here, and skip this?
                    vil.height(window.innerHeight);

                }
                else if (settings.displayMode === 'embedded') {
                    if (typeof jsPAL === "object") {
                        uScopeHeight -= $("#CommandBarHC").outerHeight(); // when embedded, compensae for the footer
                    }
                }

                if (mode == 'Initial') {
                    if (settings.displayMode == "popup") {
                        loadPopup(true);
                    }
                    else {
                        $uScope.height(uScopeHeight);
                        $uScope.width(uScopeWidth);
                    }
                }
                else if (mode == 'Resize') {
                    $uScope.height(uScopeHeight);
                    $uScope.width(uScopeWidth);
                    if (settings.displayMode !== "popup") {
                        uScope.resize(); // if popup, this will be called below
                    }
                }

                if (settings.displayMode === "popup") {
                    centerPopup();
                    uScope.resize();
                }
            }

            // debug
            /**
             if (mode != 'Resize')
             displaySizes();
             **/
        };

        /**
         * Save the entire slide tray, including positions, memos, etc.
         * @returns {deferred}
         */
        var saveDst = function () {
            var promise = {};
            // don't save the DST if a refresh is required, because the DST is no longer valid, and will be reloaded
            if (!settings.refreshRequired && !window.__isAIH) {  //TIM: running in AIH mode, don't save the DST
                try {
                    if (false === settings.dstSettings.lockMode) {
                        var currentDst = self.getDst().serialize();
                        promise = $.ajax('/DST_Save.php', {data: "Data=" + currentDst, async: false}).done(function (response) {
                            JSON.parse(response);
                            // Errors have been caught/displayed
                            self.getDst().clearModified(); // clear the DST modified flag                            
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            console.log('Error saving DST: ' + textStatus + ' ' + errorThrown);
                        });
                    }
                }
                catch (e) {

                }

            }
            return promise;
        };

        var closeDST = function () {
            if (settings.displayDST) {
                var dstDiv = self.getDst();
                if (dstDiv.length) {
                    if ($(dstDiv).is(':data(dialog)')) {
                        dstDiv.close();
                    }
                }
            }
        };

        // Display the current div sizes (debug)
        var displaySizes = function () {
            var getSize = function (comp) {
                var div = comp[0];
                if (div == null)
                    return 'N/A';

                var id = comp.attr('id');
                if (id == undefined)
                    id = div.nodeName;
                if (id == undefined)
                    id = 'unknown';
                //while (id.length < 20) // not all char widths are equal (spaces included)
                var len = id.length;
                var segments = len / 4;
                while (segments < 6) {
                    id += "\t";
                    segments++;
                }

                var x, y, width, height, pos;
                //var divPos = comp.position();
                if (div.style != undefined) {
                    x = div.style.left;
                    y = div.style.top;
                    width = div.style.width;
                    height = div.style.height;
                    pos = div.style.position;
                }
                else {
                    x = '';
                    y = '';
                    width = '';
                    height = '';
                    pos = '';
                }
                if (width == '')
                    width = Math.round(comp.width());
                if (height == '')
                    height = Math.round(comp.height());
                var offset = comp.offset();
                if (y == '') {
                    if (offset != null)
                        y = Math.round(offset.top);
                    else
                        y = '???';
                }
                //return id + 'x: ' + x + ',\ty: ' + y + ',\tw: ' + width + ',\t\th: ' + height + ',\t\tpos: ' + pos + '\n';
                return id + 'y: ' + y + ',\th: ' + height + ',\t\tpos: ' + pos + '\n';
            };

            var div;
            var str = '';
            if (settings.displayDST) {
                var dst = self.getDst();
                str += getSize(dst);
                div = dst;
            }
            if (settings.displayViewer) {
                var $uScope = self.find('#' + settings.uScope.setup.divId);
                str += getSize($uScope);
                div = $uScope;
            }

            while (true) {
                div = div.parent();
                if (div.height() == null)
                    break;
                str += getSize(div);
            }

            str += getSize($(window));

            alert(str);
        };

        /* Popup mode */
        var loadPopup = function (init) {
            if ((settings.displayMode == "popup") && !init) {
                disablePopup(true);
                return;
            }

            settings.saveHeight = self.parent().height();
            if (typeof jsPAL === 'object') {
                var tabDiv = $("#MainTabs");
                var index = jsPAL.getSelectedTabIndex(tabDiv);
                var tabs = jsPAL.getTabsForDiv(tabDiv);
                if (settings.popupTitle == "") {
                    settings.popupTitle = tabs.eq(index).children('a').first().text();
                }
            }

            settings.displayMode = "popup";
            self.insertBefore('#contentWrapper');

            self.parent().append("<div id='popupBkgd'></div>");
            $("#popupBkgd").css({"opacity": "0.7"});
            $("#popupBkgd").fadeIn("slow");

            self.prepend('<a id="popupClose">x</a>');
            self.prepend('<h1 id="popupTitle">' + settings.popupTitle + '</h1>');
            self.addClass("popup");
            $("#popup").fadeIn("slow");

            resize('Resize');

            $("#popupClose").click(function () {
                //if conferencing refresh the webpage when closing the popup
                if (_participant.confToken) {
                    $('#' + _participant.vilDivId).remove();
                    location.reload(true);
                }
                else {
                    disablePopup(true);
                }
            });
            $("#popupBkgd").click(function () {
                disablePopup(true);
            });
        };

        var centerPopup = function () {
            var wWidth = window.innerWidth;
            var wHeight = window.innerHeight;
            var vWidth = self.width();
            var vHeight = self.height();
            self.css({
                "position": "fixed",
                "top": (wHeight - vHeight) / 2,
                "left": (wWidth - vWidth) / 2
            });
        };

        var indisablePopup = false;

        var disablePopup = function () {
            // prevent recursive call when closing #confManager
            if (indisablePopup)
                return;
            indisablePopup = true;
            $("#popupClose").remove();
            $("#popupTitle").remove();
            $("#popupBkgd").remove();

            self.removeClass("popup");
            self.appendTo(settings.parentDiv);
            self.css({
                "position": "relative",
                "top": 0,
                "left": 0
            });
            settings.displayMode = "embedded";
            $("#" + settings.uScope.setup.divId).height(settings.saveHeight);
            self.height(settings.saveHeight);
            resize('Resize');
            indisablePopup = false;
        };
        /* End Popup Mode */

        /* Start Conferencing */
        var createConfSetupDialog = function (DscId, DscName) {
            leica.pi.util.conference.createConfSetupDialog(DscId, DscName);
        };
        /* End Conferencing */

        var shouldLockuScope = function () {
            // uScope should be locked if running in locked mode or running on an ios device.
            // Note, at some point we may want to not lock when in iosMode, if so, remove it from the next statement
            return settings.lockMode || settings.iosMode;
        };

        /*
         * set or clear the conference busy flag. When busy flag is true,
         * conference invitation polling is suspended
         */
        var setConferenceBusy = function (busyFlag) {
            if (window.__isAIH) {
                leica.pi.util.conference.isBusy(busyFlag);
            }
        };
        /** End Confernecing **/

        /*************************************************************************************************************
         Public FUNCTIONS -- this are the functions which are available from the instance
         *************************************************************************************************************/

        /**
         * Provide callback to override the summary text that appears above the slide tray and on the vertical collapse/expand bar
         * @param {function} callback
         * @returns {undefined}
         */
        self.setSlideTraySummaryCallback = function (callback) {
            var dst = self.getDst();
            if (dst) {
                dst.setSummaryCallback(callback);
                // update accordion panels with new summary text
                self.getDst().getActiveViewModel().isSummaryStale(true);
                self.getAccordion().refreshSummary();
            }
        };

        self.VilImageSelected = function (slide, prevSlide, source) {
            //todo: DST should package the image info instead of sending the slide 

            var viewerExists = self.find('#' + settings.uScope.setup.divId).length;
            if (viewerExists) {

                if (slide == null) {
                    self.uScopeImageUpdate("add", settings.uScope.images); //cp-what does VIL think it is adding here? cb- is it for restoring when multiple case tabs open?
                    uScope.lockDown(shouldLockuScope());
                }
//                else if (slide.isBlank && prevSlide && prevSlide.isValidSlide && !prevSlide.isBlank) {
//                    self.getDst().getActiveViewModel().closeSlide(prevSlide.encodedImageId);
//                    //self.uScopeImageUpdate("remove", {"image":  {imagePath: prevSlide.encodedImageId}});
//                }
                else {
                    var image = {
                        imagePath: slide.encodedImageId,
                        fullURL: slide.fullURL,
                                // if SaveAnnotation was read from CheckUserRights, then its value is '1' or '0'
                                // if SaveAnnotation was read from GetData, then its value is true or false.
                                // note GetData refers to 'SaveAnnotation' as 'CanEditAnnotation'
                        saveAnnotations: (slide.SaveAnnotation == 1 || slide.SaveAnnotation === true || slide.CanEditAnnotation === true)
                    };

                    if (prevSlide == null || prevSlide == undefined || prevSlide.isBlank) {
                        self.uScopeImageUpdate("add", {"image": image});
                        uScope.lockDown(shouldLockuScope());
                    }
                    else {
                        if (prevSlide.encodedImageId == "")
                            self.uScopeImageUpdate("replace", {"image": image}); // if previous was not a valid image, replace the unpinned image 
                        else
                            self.uScopeImageUpdate("replace", {"image": {imagePath: prevSlide.encodedImageId}}, {"image": image});
                    }
                }
                tabStateUpdate();
            }
        };
        var tabStateUpdate = function () {
            // if VIL running in a tab, re-enable all the tabs that were disabled during initialization
            if (self.parent().hasClass('ui-tabs-panel')) {
                var tabs = self.parent().closest('.tabs');
                tabs.tabs('enable');
                tabs.find('ul li a.ui-tabs-anchor').each(function () {
                    // remove any 'return false;' that were added to the onclick handlers
                    var onclick = $(this).attr('onclick');
                    if (onclick && onclick != '' && onclick.substring(0, 13) == 'return false;')
                        $(this).attr('onclick', onclick.substr(13));
                });
            }
        };

        self.loadSlides = function (primaryId, priorId) {
            var promise = loadSlides(primaryId, priorId);
            return promise;
        };
        self.getCurrentId = function () {
            return settings.currentId;
        };
        self.getPriorId = function () {
            return settings.priorId;
        };
        self.saveDst = function () {
            saveDst();
        };

        // save the uScope state in settings, and then close uScope
        self.uScopeSaveAndClose = function () {
            var uScopeImageState = uScope.getImageState();
            settings.uScope.images = uScopeImageState;
            uScopeEventHandlers(false); 								// remove the uScope events
            uScope.stop(); 											    // stop uScope
            self.uScopeStarted = false;
            self.find('#' + settings.uScope.setup.divId).remove(); 	    // remove the uscope div
        };
        // restore a uScope that was previously saved by uScopeSaveAndClose
        self.uScopeRestore = function () {
            if ($(settings.uScope.setup.divId, self).length == 0)
                self.append($('<div id="' + settings.uScope.setup.divId + '"></div>'));
            resize('Initial');
            if (!self.uScopeStarted) {
                self.uScopeStarted = uScope.start(settings.uScope);
            }
            selectUnpinnedSlideInTray(settings.uScope.images, false);   // if an unpinned image is specified the settings, make sure it is selected in the DST, but don't notify to avoid sending commands to reload                                                                       
            uScope.lockDown(shouldLockuScope()); 						// lock uScope if running in locked mode or in ios mode
            uScopeEventHandlers(true); 								    // attach the uScope event handlers
            resize('Resize');
        };

        /*
         * 
         *  interface method for uScopeImageUpdate
         * 
         */
        self.uScopeImageUpdate = function (action, jsonSettings, opt_jsonSettings) {
            return uScope.imageUpdate(action, jsonSettings, opt_jsonSettings);
        };

        // save the DST if it has been modified

        /**
         * Save the slide tray memos / arrangment if any have changed
         * @returns {deferred|window.$jQuery.fn.vil.saveDSTifModified.promise|window.$jQuery.fn.vil.saveDst.promise}
         */
        self.saveDSTifModified = function () {
            var promise = {};
            if (settings.displayDST) {
                var dst = self.getDst();
                if (dst.isModified()) {
                    promise = saveDst();
                }
            }
            return promise;
        };

        // Note - These get/put settings methods used to clobber the dstInfo (overwritten with dstSettings), 
        // which caused problems with conferencing when serializing the dstInfo to the DSC table
        // Fixed that problem by changeing these methods to assign the dstSettings to the VIL settings.dstSettings
        // Not sure of the full implications of this for code that calls these methods -cb 4.10.15
        self.getSettings = function () {
            settings.that = self;
            var s = Clone(settings);
            try
            {
                s.dstSettings = Clone(self.getDst().getSettings());
            }
            catch (e)
            {
            }
            return s;
        };

        self.putSettings = function (newsettings) {
            settings = Clone(newsettings);
            self = settings.that; // Umm... Doesn't this change the operational context? What happens to the old one? TODO: Is there a memory leak here?
            self.getDst().putSettings(Clone(settings.dstSettings));
        };

        self.openConferenceInvite = function (confId, confName) {
            createConfSetupDialog(confId, confName);
        };

        self.refreshVILRequired = function () {
            settings.refreshRequired = true;
        };

        self.resize = function (mode) {
            var accordion = self.getAccordion();
            if (accordion)
                accordion.setAccordionHandlerHeight();
            resize(mode);
        };
        self.initializeAccordion = function (activeIndex, vm) {
            self.getAccordion().activatePanel(activeIndex);
        };

        self.uScopeResize = function () {
            uScope.resize();
        };

        /*
         RESIZE EVENT HANDLER		 
         */

        $(window).resize(function (e) {
            // this resize handler is firing on other than window:resize events. It's not obvious from the callstack why...
            if (e.target !== window) {
                return;
            }
            // prevent recursive calls to $(window).resize in IE8
            if (settings.ignoreResize == false) {
                self.resize('Resize');
            }
            else {
                settings.ignoreResize = false;
            }
        });

        /*************************************************************************************************************
         BOOTSTRAP
         *************************************************************************************************************/
        if (typeof options == "object" && typeof options != "undefined") {
            return self.init(options); // this now returns a promise -cb
        }
        else {
            return self;
        }
    };
})(jQuery);

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

var TBPDNOPEN = 'us_tbpdnopen';

window.uScope.plugins.register({
    name: 'vil:pinDropNavigator',

    extends: 'uScope',

    canStart: function (uScope) {
        return uScope.toolbarCanAddButton('openPDNBtn');
    },

    constructor: function (uScope) {
        // The pin drop button only triggers an event. The code for it appears to live in the VIL.
        var pdnButton = $('<a/>', {
            'id': TBPDNOPEN,
            'class': 'us_tbbutton ' + TBPDNOPEN + '-e',
            'title': 'Open the pin drop navigation tool'
        });

        pdnButton.on('click', function (e) {
            if (uScope.isThisImageValid()) {
                instance && instance.eventPDNavClick();
                // note-until there is a way to know that the pin drop nav tool closes, don't change its state
            }
            return false;
        });

        uScope.topToolbar.addButton(pdnButton);
    }
});

// Hack hack hack
var instance;

module.exports = function PinDropNavigator(vil, uScope, settings) {
    var ui;

    var controls = {
        container: null,
        btnGoToFirst: null,
        btnGoToLast: null,
        btnNext: null,
        btnPrev: null,
        reset: function () {
            controls.container = controls.btnGoToFirst = controls.btnGoToLast = controls.btnNext = controls.btnPrev = null;
        }
    };

    // This is a bit hacky. The PinDrop tool has some pretty intimate knowledge of uScope's inner workings.
    var legacyUScope;

    instance = this;

    this.eventPDNavClick = function () {
        var promise = {};

        legacyUScope = legacyUScope || uScope.getLegacyUScope();

        if (ui) {
            return;
        }

        if (settings.tableName.toLowerCase() === "slide") {
            var ids = [];
            for (var i = 0; i < settings.dstInfo.cases[0].slides.length; i++) {
                ids.push(settings.dstInfo.cases[0].slides[i].id);
            }
            promise = loadPinDrops(ids);
        }
        else {
            if (settings.priorId == '')
                promise = loadPinDrops(settings.currentId);
            else
                promise = loadPinDrops(settings.priorId);
        }

        ui = $('<div>', {class: 'pdn-ui', title: 'Pin Drops'});

        controls.btnGoToFirst = $('<button>',
            {
                type: 'image',
                class: 'btnGoToFirst'
            })
            .click(function () {
                selectPindrop('first');
            });
        controls.btnGoToLast = $('<button>',
            {
                type: 'image',
                class: 'btnGoToLast'
            })
            .click(function () {
                selectPindrop('last');
            });
        controls.btnNext = $('<button>',
            {
                type: 'image',
                class: 'btnNext'
            })
            .click(function () {
                selectPindrop('next');
            });
        controls.btnPrev = $('<button>',
            {
                type: 'image',
                class: 'btnPrev'
            })
            .click(function () {
                selectPindrop('previous');
            });

        controls.container = $('<div/>', {class: 'pdn-ui-container'});

        ui.append(controls.btnGoToFirst);
        ui.append(controls.btnPrev);
        ui.append(controls.container);
        ui.append(controls.btnNext);
        ui.append(controls.btnGoToLast);
        vil.append(ui);

        ui.dialog({
            autoOpen: true,
            closeOnEscape: true,
            width: 'auto',
            height: 90,
            resizable: false,
            open: function () {
                controls.container.spin('small');
                // make the PDN dialog a child of the vil div, so it will be hidden when the vil div is hidden
                var dlg = ui.closest('.ui-dialog');
                vil.append(dlg);
                $.when(promise).done(function () {
                    selectPindrop(0); // select fist pindrop, if any
                }).always(function () {
                    controls.container.spin(false);
                });

            },
            close: function () {
                // remove "legacy" uScope reference, preventing an error if images or annotations are changed
                // after the UI is closed.
                legacyUScope = null;
                ui.remove();
                ui = null;
                controls.reset();
            }
        });
    };

    var selectPindrop = this.selectPindrop = function (displayOrder, regionId, isCallback) {
        var selectedPinDrop;

        var displayLength = getDisplayLength();
        if (displayLength === 0) {
            return;
        }

        if (displayOrder != undefined) {
            if (((displayOrder == 'first') || (displayOrder == 'previous')) && (settings.pindrop.selectedIndex == 0)) {
                return;
            }
            if (((displayOrder == 'last') || (displayOrder == 'next')) && (settings.pindrop.selectedIndex == settings.pindrop.listObj.length - 1)) {
                return;
            }

            if (displayOrder == 'last') {
                displayOrder = parseInt(settings.pindrop.listObj[settings.pindrop.listObj.length - 1].DisplayOrder);
                regionId = settings.pindrop.listObj[displayOrder].Region.Id;
            }

            else if (displayOrder == 'first') {
                displayOrder = 0;
                regionId = settings.pindrop.listObj[displayOrder].Region.Id;
            }

            else if (displayOrder == 'next') {
                displayOrder = parseInt(settings.pindrop.selectedIndex) + 1;
                regionId = settings.pindrop.listObj[displayOrder].Region.Id;
            }

            else if (displayOrder == 'previous') {
                displayOrder = parseInt(settings.pindrop.selectedIndex) - 1;
                regionId = settings.pindrop.listObj[displayOrder].Region.Id;
            }
            if (displayOrder < 0) {
                displayOrder = 0;
            }
        }
        if (regionId == undefined) {
            $.each(settings.pindrop.listObj, function (i, val) {
                if (val.DisplayOrder == displayOrder) {
                    selectedPinDrop = val;
                    regionId = selectedPinDrop.Region.Id;
                    return false;
                }
            });
        }
        else {
            $.each(settings.pindrop.listObj, function (i, val) {
                if (val.Region.Id == regionId) {
                    selectedPinDrop = val;
                    if (displayOrder == undefined) {
                        displayOrder = selectedPinDrop.DisplayOrder;
                    }
                    return false;
                }
            });
        }

        if (undefined === selectedPinDrop) {
            return;
        }
        settings.pindrop.selectedIndex = displayOrder;
        settings.pindrop.selectedRegionId = regionId;

        loadList(displayOrder);

        for (var i = 1; i <= displayLength; i++) {
            $('#vil' + settings.currentId + 'pd_' + i).removeClass('selected');
        }

        $('#vil' + settings.currentId + 'pd_' + displayOrder).addClass('selected');

        if (settings.pindrop.selectedIndex == 0) {
            controls.btnGoToFirst.addClass('disabled');
            controls.btnPrev.addClass('disabled');
        }
        else {
            controls.btnGoToFirst.removeClass('disabled');
            controls.btnPrev.removeClass('disabled');
        }

        if (settings.pindrop.selectedIndex == settings.pindrop.listObj.length - 1) {
            controls.btnGoToLast.addClass('disabled');
            controls.btnNext.addClass('disabled');
        }
        else {
            controls.btnGoToLast.removeClass('disabled');
            controls.btnNext.removeClass('disabled');
        }

        // If the pin drop being selected is not in the current image, we need to switch to another image,
        // unless the image is already pinned and therefore open in pane, in which case just move the pindrop into view
        var selectedImageId = legacyUScope.getSelImageId();
        if (selectedPinDrop.ImageId != selectedImageId && !isImagePinned(selectedPinDrop.ImageId)) {
            if (settings.displayDST) {
                vil.getDst().selectImageByImageId(selectedPinDrop.ImageId.substr(1)); // select the slide in the tray; this will automatically replace it in uScope
            }
            else {
                var newImage = {
                    imagePath: selectedPinDrop.ImageId,
                    fullURL: selectedPinDrop.fullURL,
                    regionId: regionId
                };
                vil.uScopeImageUpdate("replace", {"image": {imagePath: selectedImageId}}, {"image": newImage});
            }
        }
        else {
            if (!isCallback) {
                uScope.goToRegion(selectedPinDrop.ImageId, regionId);
            }
        }
    };

    this.eventAnnotChange = function (imageId, regionId, anShape, action) {
        if (!legacyUScope || anShape !== 'pin') {
            return;
        }
        switch (action) {
            case 'sel':
                selectPindrop(undefined, regionId, true);
                break;
            case 'add':
                settings.pindrop.listObj.push(
                    {
                        "Id": regionId,
                        "ImageId": imageId,
                        "fullURL": legacyUScope.getThisImageById(imageId).getFullURL(), // Change to get image by id, or pass URL as an event parameter
                        "DisplayOrder": settings.pindrop.listObj.length.toString(),
                        "Region": {
                            "Id": regionId.toString()
                        }
                    });
                loadList(settings.pindrop.listObj.length);
                selectPindrop(undefined, regionId, true);
                break;
            case 'del':
                if (ui) {
                    return;
                }
                var index = getIndexForRegionId(regionId);
                if (index > -1) {
                    // remove the region from the pindrop listObj
                    settings.pindrop.listObj.splice(index, 1);
                    // update the display order for the regions following the deleted region
                    for (var i = index; i < settings.pindrop.listObj.length; i++) {
                        --settings.pindrop.listObj[i].DisplayOrder;
                    }
                }
                if (regionId === settings.pindrop.selectedRegionId) {
                    settings.pindrop.selectedRegionId = 0;
                }
                if (settings.pindrop.selectedRegionId > 0) {
                    // note, when a pindrop is deleted, uScope first sends a 'sel' action for the new region to select
                    // before it sends the 'del', so need to reselect the previously selected pindrop here
                    // also note, uScope sends the 'sel' only if there are remaining regions on the current image
                    selectPindrop(undefined, settings.pindrop.selectedRegionId, true);
                }
                else {
                    // this happens when there are no more regions on the current image
                    if (index < 0) {
                        index = 0;
                    }
                    else if (index >= settings.pindrop.listObj.length) {
                        index = settings.pindrop.listObj.length - 1;
                    }
                    loadList(index);
                    selectPindrop(index, undefined, true);
                }
                break;
        }
    };

    var loadPinDrops = this.loadPinDrops = function (ids) {
        var Parms = 'TableName=' + settings.tableName;
        if ($.isArray(ids)) {
            for (var i = 0; i < ids.length; i++) {
                Parms += '&Ids[]=' + ids[i];
            }
        }
        else {
            Parms += '&Ids[]=' + ids;
        }

        var defer = $.Deferred(); // use deferred to wait for _both_ AJAX call _and_ processing of pindrops (loadList)
        var promise = $.getJSON('/PDN_Get.php', Parms)
            .done(function (data) {
                if (data && data.PinDrop && data.PinDrop.length > 0) {
                    settings.pindrop.listObj = data.PinDrop;
                    loadList(0);
                }
                else {
                    controls.container.append($('<p>').text('No Pindrops').css('margin', 3));
                }
                defer.resolve(); // pindrops have been requested and (if any present) returned from the server _and_ processed (loaded into memory structure in settings object)
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                alert('Error getting pindrops: ' + textStatus + ' ' + errorThrown);
            });

        return $.when(promise, defer); // returns immediately, but clients can use to hook callback for code that must only run after pindrops loaded _and_ processed

    };

    var getDisplayLength = function () {
        var displayLength = settings.pindrop.listObj.length;
        if (displayLength > settings.pindrop.maxPindrops) {
            displayLength = settings.pindrop.maxPindrops; // no greater than settings.pindrop.maxPindrops displayed at a time
        }
        return displayLength;
    };

    var getStartIndex = function (selectedIndex) {
        var startIndex = 1;
        if ((settings.pindrop.listObj.length > settings.pindrop.maxPindrops) && (selectedIndex > 3)) {
            startIndex = selectedIndex - 2;
        }
        if (startIndex < 1) {
            startIndex = 1;
        }

        var offset = 4;
        if (offset > settings.pindrop.listObj.length) {
            offset = settings.pindrop.listObj.length - 1;
        }

        if (startIndex > settings.pindrop.listObj.length - offset) {
            startIndex = settings.pindrop.listObj.length - offset;
        }

        if (startIndex < 1) {
            startIndex = 1;
        }

        return startIndex;
    };

    var getLastIndex = function (startIndex, displayLength) {
        var lastIndex = settings.pindrop.listObj.length;
        if (settings.pindrop.listObj.length < settings.pindrop.maxPindrops) {
            return settings.pindrop.listObj.length;
        }

        if (lastIndex > settings.pindrop.maxPindrops) {
            lastIndex = settings.pindrop.maxPindrops;
        }
        var listLength = settings.pindrop.listObj.length;

        if ((listLength > startIndex) && (listLength > displayLength)) {
            lastIndex = startIndex + 4;
        }

        return lastIndex;
    };

    // Add pin drop links
    var appendLink = function (count) {
        var link = $("<a id='vil" + settings.currentId + "pd_" + (count - 1) + "'>" + (count) + "</a>");
        controls.container.append(link);
        link.click(function () {
            if (undefined !== settings.pindrop.listObj[count - 1]) {
                var pindrop = settings.pindrop.listObj[count - 1];
                if (undefined !== pindrop) {
                    selectPindrop(undefined, pindrop.Region.Id);
                }
            }
        });
    };

    var appendEmptyLink = function (count) {
        var link = $("<a disabled='disabled' id='vil" + settings.currentId + "pd_" + (count - 1) + "'>&nbsp;&nbsp;</a>");
        controls.container.append(link);
    };

    var clearList = function () {
        controls.container && controls.container.empty();
    };

    var loadList = function (id) {
        clearList();
        var startIndex = getStartIndex(id);
        var displayLength = getDisplayLength();
        var lastIndex = getLastIndex(startIndex, displayLength);
        for (var i = startIndex; i <= lastIndex; i++) {
            appendLink(i);
        }
        for (; i < startIndex + settings.pindrop.maxPindrops; i++) {
            appendEmptyLink(i);
        }
    };

    var getIndexForRegionId = function (regionId) {
        var index = -1;
        $.each(settings.pindrop.listObj, function (i, val) {
            if (val.Region.Id == regionId) {
                index = i;
                return false;
            }
        });
        return index;
    };

    // Check if an image is pinned in a pane
    var isImagePinned = function (imagePath) {
        var result = false;
        // loop through the pane array, looking to see if image id is present
        $.each(legacyUScope.getStateArray(), function (i, val) {
            if (val.imagePath == imagePath && val.isPinned) {
                result = true;
                return false;
            }
        });
        return result;
    };
};


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
module.exports = __webpack_require__(6);


/***/ })
/******/ ]);